/* ═══════════════════════════════════════════════
   Mithila Foods -Modern Wishlist Controller
   ═══════════════════════════════════════════════ */

(function () {
  'use strict';

  var STORAGE_KEY = 'mf_wishlist';

  /* ── Storage helpers ── */
  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isWishlisted(handle) {
    return getList().some(function (p) { return p.handle === handle; });
  }

  /* Escape text for safe HTML interpolation */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function toggleItem(product) {
    var list = getList();
    var idx = list.findIndex(function (p) { return p.handle === product.handle; });
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push(product);
    }
    saveList(list);
    return idx < 0; /* true = added */
  }

  /* ── Update all heart buttons on the page for a handle ── */
  function syncHearts(handle, active) {
    var safe = (window.CSS && CSS.escape) ? CSS.escape(handle) : handle.replace(/["\\]/g, '\\$&');
    document.querySelectorAll('[data-wishlist-btn][data-handle="' + safe + '"], [data-wishlist-handle="' + safe + '"]').forEach(function (btn) {
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('title', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  /* ── Update header counter badge ── */
  function updateCounter() {
    var count = getList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ── Product fetch & resolution helpers ── */
  var productInfoCache = {};

  function fetchProductInfo(handle) {
    if (!handle) return Promise.reject(new Error('No handle provided'));
    if (productInfoCache[handle]) {
      return Promise.resolve(productInfoCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch product data for ' + handle);
        return res.json();
      })
      .then(function (data) {
        productInfoCache[handle] = data;
        return data;
      });
  }

  /* Auto-resolve missing variantId, availability, price and images for items */
  function resolveMissingVariants(list) {
    var needsUpdate = false;
    var promises = list.map(function (p) {
      if (!p.variantId || p.available === undefined) {
        return fetchProductInfo(p.handle)
          .then(function (data) {
            if (!data || !data.variants || data.variants.length === 0) return p;
            var variant = data.variants.find(function (v) { return v.available; }) || data.variants[0];
            if (variant) {
              p.variantId = variant.id;
              p.available = variant.available;
              if (!p.price && variant.price) {
                p.price = 'Rs. ' + (variant.price / 100).toFixed(2);
              }
              if (!p.comparePrice && variant.compare_at_price) {
                p.comparePrice = 'Rs. ' + (variant.compare_at_price / 100).toFixed(2);
              }
              if (!p.image && data.featured_image) {
                p.image = data.featured_image;
              }
              needsUpdate = true;
            }
            return p;
          })
          .catch(function (err) {
            console.warn('Could not resolve variant for', p.handle, err);
            return p;
          });
      }
      return Promise.resolve(p);
    });

    return Promise.all(promises).then(function (resolvedList) {
      if (needsUpdate) {
        saveList(resolvedList);
      }
      return resolvedList;
    });
  }

  /* ── AJAX Add to Cart Helper ── */
  function addToCart(items) {
    var payload = Array.isArray(items) ? { items: items } : items;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function (data) {
      if (typeof window.mfRefreshCart === 'function') {
        return window.mfRefreshCart().then(function () { return data; });
      }
      return data;
    });
  }

  /* Open Cart Drawer if available */
  function openCartDrawer() {
    if (typeof window.mfOpenCartDrawer === 'function') {
      window.mfOpenCartDrawer();
      return;
    }
    window.dispatchEvent(new CustomEvent('cart:open'));
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  /* ── Render Drawer Contents ── */
  function renderDrawer(skipAutoResolve) {
    var body     = document.getElementById('mf-wishlist-body');
    var empty    = document.getElementById('mf-wishlist-empty');
    var counter  = document.getElementById('mf-wishlist-drawer-count');
    var clearBtn = document.getElementById('mf-wishlist-clear-all');
    var footer   = document.getElementById('mf-wishlist-footer');

    if (!body) return;

    var list = getList();
    var count = list.length;

    if (counter) {
      counter.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    }

    if (count === 0) {
      body.innerHTML = '';
      body.style.display = 'none';
      if (empty) empty.style.display = 'flex';
      if (clearBtn) clearBtn.style.display = 'none';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    body.style.display = 'flex';
    if (clearBtn) clearBtn.style.display = 'inline-block';
    if (footer) footer.style.display = 'flex';

    /* Background resolution for legacy/missing items */
    var hasMissing = list.some(function (p) { return !p.variantId; });
    if (hasMissing && !skipAutoResolve) {
      resolveMissingVariants(list).then(function () {
        renderDrawer(true);
      });
    }

    body.innerHTML = list.map(function (p) {
      var priceHtml = '<span class="mf-wl-item__price">' + esc(p.price) + '</span>';
      if (p.comparePrice && p.comparePrice !== p.price) {
        priceHtml += '<span class="mf-wl-item__compare">' + esc(p.comparePrice) + '</span>';
      }

      var atcBtnHtml = '';
      if (p.available === false) {
        atcBtnHtml = '<button type="button" class="mf-wl-item__atc" disabled>Sold Out</button>';
      } else {
        atcBtnHtml = '<button type="button" class="mf-wl-item__atc" data-atc-variant="' + esc(p.variantId || '') + '" data-handle="' + esc(p.handle) + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>' +
          '</svg>' +
          '<span>Add to Cart</span>' +
        '</button>';
      }

      return '<div class="mf-wl-item" data-handle="' + esc(p.handle) + '">' +
        '<a href="' + esc(p.url) + '" class="mf-wl-item__img-link">' +
          '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' +
        '</a>' +
        '<div class="mf-wl-item__info">' +
          '<a href="' + esc(p.url) + '" class="mf-wl-item__title">' + esc(p.title) + '</a>' +
          '<div class="mf-wl-item__price-row">' + priceHtml + '</div>' +
          '<div class="mf-wl-item__actions">' + atcBtnHtml + '</div>' +
        '</div>' +
        '<button type="button" class="mf-wl-item__remove" data-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
          '</svg>' +
        '</button>' +
      '</div>';
    }).join('');

    /* Bind remove buttons */
    body.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.remove;
        var itemCard = btn.closest('.mf-wl-item');
        if (itemCard) {
          itemCard.classList.add('is-removing');
          setTimeout(function () {
            var currentList = getList();
            saveList(currentList.filter(function (p) { return p.handle !== handle; }));
            syncHearts(handle, false);
            updateCounter();
            renderDrawer();
          }, 200);
        } else {
          var currentList = getList();
          saveList(currentList.filter(function (p) { return p.handle !== handle; }));
          syncHearts(handle, false);
          updateCounter();
          renderDrawer();
        }
      });
    });

    /* Bind single Add to Cart buttons */
    body.querySelectorAll('.mf-wl-item__atc:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.atcVariant;
        var handle = btn.dataset.handle;
        var originalHtml = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<span>Adding...</span>';

        function sendAddToCart(vId) {
          addToCart({ id: vId, quantity: 1 })
            .then(function () {
              btn.classList.add('is-added');
              btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> <span>Added!</span>';
              setTimeout(function () {
                closeDrawer();
                openCartDrawer();
              }, 450);
            })
            .catch(function (err) {
              console.error('Wishlist ATC error:', err);
              btn.disabled = false;
              btn.innerHTML = originalHtml;
              alert('Could not add to cart. Please try again or visit product page.');
            });
        }

        if (variantId) {
          sendAddToCart(variantId);
        } else if (handle) {
          fetchProductInfo(handle)
            .then(function (data) {
              var v = (data.variants && data.variants.find(function (x) { return x.available; })) || (data.variants && data.variants[0]);
              if (v && v.id) {
                var curList = getList();
                var item = curList.find(function (p) { return p.handle === handle; });
                if (item) {
                  item.variantId = v.id;
                  item.available = v.available;
                  saveList(curList);
                }
                sendAddToCart(v.id);
              } else {
                window.location.href = '/products/' + handle;
              }
            })
            .catch(function () {
              window.location.href = '/products/' + handle;
            });
        }
      });
    });
  }

  /* ── Open / Close Drawer ── */
  var lastFocused = null;
  var globalListenersBound = false;

  function isDrawerOpen() {
    var drawer = document.getElementById('mf-wishlist-drawer');
    return !!(drawer && drawer.classList.contains('is-open'));
  }

  function openDrawer() {
    renderDrawer();
    var drawer = document.getElementById('mf-wishlist-drawer');
    var overlay = document.getElementById('mf-wishlist-overlay');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.style.display = 'block'; // ensure it covers the viewport for outside-click close
    }
    document.body.style.overflow = 'hidden';
    lastFocused = document.activeElement;
    var closeBtn = document.getElementById('mf-wishlist-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById('mf-wishlist-drawer');
    var overlay = document.getElementById('mf-wishlist-overlay');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  /* ── High-End D2C Luxury Floating Wishlist Toast ── */
  var toastTimer = null;
  function showWishlistToast(isAdded) {
    var toast = document.getElementById('mf-wl-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mf-wl-toast';
      toast.className = 'mf-wl-toast';
      toast.innerHTML =
        '<span class="mf-wl-toast__icon"></span>' +
        '<span class="mf-wl-toast__msg"></span>' +
        '<span class="mf-wl-toast__divider">·</span>' +
        '<button type="button" class="mf-wl-toast__action">View <span aria-hidden="true">&rarr;</span></button>';
      document.body.appendChild(toast);

      var actionBtn = toast.querySelector('.mf-wl-toast__action');
      if (actionBtn) {
        actionBtn.addEventListener('click', function () {
          openDrawer();
          toast.classList.remove('is-visible');
        });
      }
    }

    var iconEl = toast.querySelector('.mf-wl-toast__icon');
    var msgEl = toast.querySelector('.mf-wl-toast__msg');
    var dividerEl = toast.querySelector('.mf-wl-toast__divider');
    var actionBtn = toast.querySelector('.mf-wl-toast__action');

    if (isAdded) {
      if (iconEl) {
        iconEl.innerHTML =
          '<svg viewBox="0 0 24 24" fill="#e53e3e" stroke="#e53e3e" stroke-width="1"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      }
      if (msgEl) msgEl.textContent = 'Saved to wishlist';
      if (dividerEl) dividerEl.style.display = 'inline';
      if (actionBtn) actionBtn.style.display = 'inline-flex';
    } else {
      if (iconEl) {
        iconEl.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      }
      if (msgEl) msgEl.textContent = 'Removed from wishlist';
      if (dividerEl) dividerEl.style.display = 'none';
      if (actionBtn) actionBtn.style.display = 'none';
    }

    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /* ── Init Heart Buttons on Cards ── */
  function initHearts() {
    document.querySelectorAll('[data-wishlist-btn], [data-wishlist-handle], .mf-wl-btn').forEach(function (btn) {
      var handle = btn.dataset.handle || btn.dataset.wishlistHandle;
      if (!handle) return;

      /* Set initial UI state */
      var active = isWishlisted(handle);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('title', active ? 'Remove from wishlist' : 'Add to wishlist');

      if (!btn.dataset.wlInited) {
        btn.dataset.wlInited = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var title = btn.dataset.title || handle.replace(/-/g, ' ');
          var product = {
            handle: handle,
            title: title,
            price: btn.dataset.price || '',
            comparePrice: btn.dataset.comparePrice || '',
            image: btn.dataset.image || '',
            url: btn.dataset.url || ('/products/' + handle),
            variantId: btn.dataset.variantId || '',
            available: btn.dataset.available !== 'false'
          };

          var added = toggleItem(product);
          syncHearts(handle, added);
          updateCounter();

          /* Micro-bounce animation */
          btn.classList.add('mf-wl-pop');
          setTimeout(function () { btn.classList.remove('mf-wl-pop'); }, 400);

          showWishlistToast(added);
        });
      }
    });
  }

  /* ── Init Drawer Controls ── */
  function initDrawer() {
    /* Open trigger buttons across header / mobile nav */
    document.querySelectorAll('[data-wishlist-open]').forEach(function (el) {
      if (el.dataset.wlOpenInited) return;
      el.dataset.wlOpenInited = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    /* Top Cart button in header of Wishlist Drawer */
    var cartBtn = document.getElementById('mf-wishlist-cart-btn');
    if (cartBtn && !cartBtn.dataset.wlInited) {
      cartBtn.dataset.wlInited = '1';
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
        setTimeout(function () {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            var bubble = document.querySelector('#cart-icon-bubble');
            if (bubble) bubble.click();
            else window.location.href = '/cart';
          }
        }, 120);
      });
    }

    /* Close button */
    var closeBtn = document.getElementById('mf-wishlist-close');
    if (closeBtn && !closeBtn.dataset.wlInited) {
      closeBtn.dataset.wlInited = '1';
      closeBtn.addEventListener('click', closeDrawer);
    }

    /* Overlay click to close */
    var overlay = document.getElementById('mf-wishlist-overlay');
    if (overlay && !overlay.dataset.wlInited) {
      overlay.dataset.wlInited = '1';
      overlay.addEventListener('click', closeDrawer);
    }

    /* Clear all button */
    var clearBtn = document.getElementById('mf-wishlist-clear-all');
    if (clearBtn && !clearBtn.dataset.wlInited) {
      clearBtn.dataset.wlInited = '1';
      clearBtn.addEventListener('click', function () {
        var list = getList();
        if (list.length === 0) return;
        saveList([]);
        list.forEach(function (p) { syncHearts(p.handle, false); });
        updateCounter();
        renderDrawer();
      });
    }

    /* Footer "Add All to Cart" */
    var addAllBtn = document.getElementById('mf-wishlist-add-all');
    if (addAllBtn && !addAllBtn.dataset.wlInited) {
      addAllBtn.dataset.wlInited = '1';
      addAllBtn.addEventListener('click', function () {
        var list = getList();
        if (list.length === 0) {
          alert('Your wishlist is empty.');
          return;
        }

        var origHtml = addAllBtn.innerHTML;
        addAllBtn.disabled = true;
        addAllBtn.innerHTML = '<span>Adding all items...</span>';

        resolveMissingVariants(list)
          .then(function (resolvedList) {
            var itemsToAdd = [];
            resolvedList.forEach(function (p) {
              if (p.variantId && p.available !== false) {
                itemsToAdd.push({ id: p.variantId, quantity: 1 });
              }
            });

            if (itemsToAdd.length === 0) {
              addAllBtn.disabled = false;
              addAllBtn.innerHTML = origHtml;
              alert('No available items in stock to add to cart.');
              return;
            }

            return addToCart(itemsToAdd)
              .then(function () {
                addAllBtn.innerHTML = '<span>✓ Added to Cart!</span>';
                setTimeout(function () {
                  addAllBtn.disabled = false;
                  addAllBtn.innerHTML = origHtml;
                  closeDrawer();
                  openCartDrawer();
                }, 500);
              });
          })
          .catch(function (err) {
            console.error('Add all to cart error:', err);
            addAllBtn.disabled = false;
            addAllBtn.innerHTML = origHtml;
            alert('Could not add items to cart. Please try again.');
          });
      });
    }

    /* Footer "Continue Shopping" */
    var continueBtn = document.getElementById('mf-wishlist-continue');
    if (continueBtn && !continueBtn.dataset.wlInited) {
      continueBtn.dataset.wlInited = '1';
      continueBtn.addEventListener('click', closeDrawer);
    }

    /* Empty state explore links close drawer on click */
    var emptyCta = document.getElementById('mf-wishlist-explore-btn');
    if (emptyCta && !emptyCta.dataset.wlInited) {
      emptyCta.dataset.wlInited = '1';
      emptyCta.addEventListener('click', function () {
        closeDrawer();
      });
    }

    document.querySelectorAll('.mf-wl-chip').forEach(function (chip) {
      if (chip.dataset.wlInited) return;
      chip.dataset.wlInited = '1';
      chip.addEventListener('click', function () {
        closeDrawer();
      });
    });

    /* Document/window listeners -bind once only */
    if (globalListenersBound) return;
    globalListenersBound = true;

    /* Esc key closes drawer */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isDrawerOpen()) closeDrawer();
    });

    /* Cross-tab sync */
    window.addEventListener('storage', function (e) {
      if (e.key !== STORAGE_KEY) return;
      updateCounter();
      document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
        var h = btn.dataset.handle;
        if (h) syncHearts(h, isWishlisted(h));
      });
      if (isDrawerOpen()) renderDrawer();
    });
  }

  /* ── Public Init ── */
  function init() {
    initDrawer();
    initHearts();
    updateCounter();
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Global API */
  window.MFWishlist = {
    init: function () {
      initHearts();
      initDrawer();
    },
    open: openDrawer,
    close: closeDrawer,
    render: renderDrawer,
    getList: getList,
    resolveMissingVariants: resolveMissingVariants
  };

})();
